import { APP_VERSION } from "@lib/constants/AppConst";

export const isDev = () => {
  return process.env.NODE_ENV === "development";
};

export const isProd = () => {
  return process.env.NODE_ENV === "production";
};

export const getVersionNumber = (): number => {
  return parseInt(APP_VERSION.split(".").join(""));
};
